export default {"src":"/_next/static/media/0xba4cfe5741b357fa371b506e5db0774abfecf8fc.bfbc37e8.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};